<template>
  <div v-loading="loading" class="main-frame" :element-loading-text="$t('commonInfo.Loading')">
    <el-container>
      <el-header class="banner-head">
        <div class="head-info">
          <el-row>
            <el-col style="text-align: left" :span="24">
              <el-page-header
                style="color: #333333"
                :title="$t('commonInfo.Back')"
                @back="goBack"
                :content="$t('commonInfo.StoreList')"
              ></el-page-header>
            </el-col>
          </el-row>
        </div>
      </el-header>

      <el-main>
        <el-form class="search_table_info" ref="form" :inline="true" :model="form">
          <el-form-item :label="$t('storeMessage.Country') + '：'">
            <el-select
              v-model.trim="form.country_id"
              @change="get_country_info($event)"
              :placeholder="$t('storeMessage.SelectCountry')"
              clearable
            >
              <el-option
                :label="item.name"
                :value="item.id"
                :key="item.id"
                v-for="item in form.country_list"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('storeMessage.Province') + '：'">
            <el-select
              :disabled="country_focus_flag"
              v-model.trim="form.province_id"
              @change="get_province_info($event)"
              :placeholder="$t('storeMessage.SelectProvince')"
              clearable
            >
              <el-option
                :label="item.name"
                :value="item.id"
                :key="item.id"
                v-for="item in form.province_list"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('storeMessage.City') + '：'">
            <el-select
              :disabled="country_focus_flag"
              v-model.trim="form.city_id"
              @change="get_city_info($event)"
              :placeholder="$t('storeMessage.SelectCity')"
              clearable
            >
              <el-option
                :label="item.name"
                :value="item.id"
                :key="item.id"
                v-for="item in form.city_list"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('storeMessage.CompanyName') + '：'">
            <el-input
              v-model.trim="form.company_name"
              :placeholder="$t('storeMessage.SelectCompanyName')"
              style="padding-right: 14px"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('storeMessage.TypeOfRetailArea') + '：'" prop="retail_type_text">
            <el-select
              v-model.trim="form.retail_area_type_id"
              @change="get_retail_area_type_info($event)"
              :placeholder="$t('storeMessage.SelectRetailArea')"
              clearable
            >
              <el-option
                :label="item.name"
                :value="item.id"
                :key="item.id"
                v-for="item in form.retail_area_type_list"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-switch
              v-model.trim="form.newest"
              @change="switch_new_old"
              :active-text="$t('storeMessage.newest')"
              :inactive-text="$t('storeMessage.Oldest')"
            ></el-switch>
          </el-form-item>

          <el-form-item :label="$t('storeMessage.area') + '：'">
            <el-select
              :disabled="country_focus_flag"
              v-model.trim="form.area_score_id"
              multiple
              @change="select_store_area($event)"
              :placeholder="$t('storeMessage.SelectCompanyArea')"
              collapse-tags
              clearable
            >
              <el-option
                :label="item.size_range"
                :value="item.id"
                :key="item.id"
                v-for="item in form.area_score_list"
              >
                <span style="float: left; color: #8492a6; font-size: 13px">
                  {{
                  item.size_range
                  }}
                </span>
                <span
                  style="
                    float: right;
                    color: #8492a6;
                    font-size: 13px;
                    padding-right: 30px;
                  "
                >{{ item.area_unit }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('storeMessage.SellOutMoney') + '：'">
            <el-select
              :disabled="country_focus_flag"
              v-model.trim="form.turnover_score_id"
              multiple
              @change="get_turnover_score_info($event)"
              :placeholder="$t('storeMessage.SelectMonthlySellOut')"
              collapse-tags
              clearable
            >
              <el-option
                :label="item.size_range"
                :value="item.id"
                :key="item.id"
                v-for="item in form.turnover_score_list"
              >
                <span style="float: left; color: #8492a6; font-size: 13px">
                  {{
                  item.size_range
                  }}
                </span>
                <span
                  style="
                    float: right;
                    color: #8492a6;
                    font-size: 13px;
                    padding-right: 30px;
                  "
                >{{ item.turnover_unit }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('storeMessage.SMOKSellOutMoney') + '：'">
            <el-select
              :disabled="country_focus_flag"
              v-model.trim="form.smokturnover_score_id"
              multiple
              @change="get_smokturnover_score_info($event)"
              :placeholder="$t('storeMessage.SelectMonthlySmokSellOut')"
              collapse-tags
              clearable
            >
              <el-option
                :label="item.size_range"
                :value="item.id"
                :key="item.id"
                v-for="item in form.smok_turnover_score_list"
              >
                <span style="float: left; color: #8492a6; font-size: 13px">
                  {{
                  item.size_range
                  }}
                </span>
                <span
                  style="
                    float: right;
                    color: #8492a6;
                    font-size: 13px;
                    padding-right: 30px;
                  "
                >{{ item.turnover_unit }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('storeMessage.StoreLevel') + '：'">
            <el-select
              v-model.trim="form.grade_level"
              @change="get_grade_level($event)"
              :placeholder="$t('storeMessage.SelectCompanyLevel')"
              collapse-tags
              clearable
            >
              <el-option
                :label="item.id"
                :value="item.level"
                :key="item.id"
                v-for="item in form.grade_level_list"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="float: right">
            <el-button type="primary" @click="trigger_upload_button">
              {{
              $t("storeMessage.UploadFiles")
              }}
            </el-button>
          </el-form-item>
          <el-form-item style="display: none" label>
            <el-row>
              <el-col style="text-align: left" :span="16">
                <label class="btn btn-md btn-info" for="file_upload"></label>
                <input
                  ref="upload_file_button"
                  type="file"
                  name="file_upload"
                  @change="submitFile($event)"
                  accept=".xlsx"
                  multiple
                  id="file_upload"
                />
              </el-col>
            </el-row>
            <!-- </button> -->
          </el-form-item>

          <el-form-item style="float: right">
            <el-button type="primary" @click="query_store_info">
              {{
              $t("storeMessage.Search")
              }}
            </el-button>
            <el-button type="primary" @click="export_excel">
              {{
              $t("storeMessage.DownloadTheFile")
              }}
            </el-button>
            <el-button type="primary" @click="update_score">
              {{
              $t("storeMessage.UpdateScore")
              }}
            </el-button>
          </el-form-item>
        </el-form>

        <!-- 表格渲染 -->
        <el-table :data="store_info_list" style="width: 100%" strip border default-expand-all>
          <el-table-column label="#" width="180" align="center">
            <template slot-scope="scope">
              <p style="font-weight: bold">{{ scope.$index + 1 }}</p>
            </template>
          </el-table-column>

          <el-table-column prop="country_name" :label="$t('storeMessage.Country')" align="center"></el-table-column>
          <el-table-column prop="province_name" :label="$t('storeMessage.Province')" align="center"></el-table-column>
          <el-table-column prop="city_name" :label="$t('storeMessage.City')" align="center"></el-table-column>
          <el-table-column
            prop="company_name"
            :label="$t('storeMessage.CompanyName')"
            align="center"
          ></el-table-column>
          <el-table-column prop="score" :label="$t('storeMessage.Score')" align="center"></el-table-column>
          <el-table-column
            prop="transformed_grade"
            :label="$t('storeMessage.StoreLevel')"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="retail_area_type_name"
            :label="$t('storeMessage.TypeOfRetailArea')"
            align="center"
          ></el-table-column>
          <el-table-column :label="$t('storeMessage.Operation')" align="center">
            <template slot-scope="scope">
              <el-button
                size="small"
                type="primary"
                @click="edit_model(scope.row)"
              >{{ $t("storeMessage.Edit") }}</el-button>
              <el-button
                size="small"
                type="primary"
                @click="remove_model(scope.row)"
              >{{ $t("storeMessage.Delete") }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer class="footer_info">
        <el-pagination
          style="margin-top: 15px"
          background
          layout="sizes,prev, pager, next, jumper"
          :page-sizes="[20, 50, 100, 150]"
          :page-size="page_size"
          @size-change="handleSizeChange"
          :pager-count="9"
          :total="page_total"
          :current-page="page_number"
          @current-change="currentChangeOnclick"
        ></el-pagination>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
export default {
  name: "StoreMessage",
  data() {
    return {
      loading: false,
      form: {
        country_list: [],
        province_list: [],
        city_list: [],
        country_id: "",
        province_id: "",
        city_id: "",
        retail_area_type_id: "", //零售区类型id
        area_score_id: [], //门店面积id
        turnover_score_id: [], //营业额id
        smokturnover_score_id: [], //smok营业额id
        company_name: "", //门店名称
        // zip: "", //邮编
        newest: true,
        oldest: true,
        page_flag: 1, //切换最新和最旧数据
        address: "", //门店地址
        area_size: "",
        turnover: "",
        smok_turnover: "",
        country: [],
        retail_area_type_list: [], //零售区类型
        area_score_list: [], //评分面积范围
        turnover_score_list: [], //营业额范围
        smok_turnover_score_list: [], //smok营业额范围
        grade_level_list: [
          {
            level: 1,
            id: "A"
          },
          {
            level: 2,
            id: "B"
          },
          {
            level: 3,
            id: "C"
          }
        ]
      },
      store_info_list: [], //门店表格
      // 分页部分
      page_total: 0,
      page_size: 20,
      page_number: 1,
      country_focus_flag: true
    };
  },
  methods: {
    submitFile: function(e) {
      let _me = this;
      _me.loading = true;
      let btnId = "file_upload";
      let file = document.getElementById(btnId).files[0];
      if (file) {
        let reader = new FileReader();
        reader.readAsText(file, "UTF-8");
        reader.onload = function() {
          let formData = new FormData();
          formData.append("file", file);
          _me.$common
            .httpFilePost("/api/store/admin/upload/excel", formData)

            .then(res => {
              _me.loading = false;
              if (res.code == 1000000) {
                _me.$confirm(
                  _me.$t("commonInfo.ImportSucceeded"),
                  _me.$t("commonInfo.Tips"),
                  {
                    confirmButtonText: _me.$t("commonInfo.Confirm"),
                    cancelButtonText: _me.$t("commonInfo.Cancel"),
                    type: "warning"
                  }
                );
              } else {
                _me.$confirm(res.message, _me.$t("commonInfo.Tips"), {
                  confirmButtonText: _me.$t("commonInfo.Confirm"),
                  cancelButtonText: _me.$t("commonInfo.Cancel"),
                  type: "warning"
                });
                // _me.$message.error(res.message);
              }
            })
            .catch(err => {
              _me.loading = false;
              if (err.code == 1000009 || err.code == 1000007) {
                _me.$router.push("sign-in");
              } else {
                _me.$confirm(err.message, _me.$t("commonInfo.Tips"), {
                  confirmButtonText: _me.$t("commonInfo.Confirm"),
                  cancelButtonText: _me.$t("commonInfo.Cancel"),
                  type: "warning"
                });
                // _me.$message.error(err.message);
              }
            });
        };
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    // 获取省份列表
    get_province_list(country_id) {
      let _me = this;
      _me.loading = true;
      let params = {
        id: country_id
      };
      this.$common
        .httpPost("/api/address/province/find/list", params)
        .then(res => {
          _me.loading = false;
          if (res.code == "1000000") {
            this.form.province_list = res.data;
          } else {
            _me.$message.error(res.message);
          }
        })
        .catch(err => {
          _me.loading = false;
          if (err.code == 1000009 || err.code == 1000007) {
            this.$router.push("sign-in");
          }
          _me.$message.error(err.message);
        });
    },
    // 获取城市列表
    get_city_list(city_id) {
      let _me = this;
      _me.loading = true;
      let params = {
        id: city_id
      };
      this.$common
        .httpPost("/api/address/city/find/list", params)
        .then(res => {
          _me.loading = false;
          if (res.code == "1000000") {
            this.form.city_list = res.data;
          } else {
            _me.$message.error(res.message);
          }
        })
        .catch(err => {
          _me.loading = false;
          if (err.code == 1000009 || err.code == 1000007) {
            this.$router.push("sign-in");
          }
          _me.$message.error(err.message);
        });
    },
    // 获取国家id并获取省份列表
    get_country_info(e) {
      this.form.country_id = e;
      this.form.province_id = "";
      this.form.city_id = "";
      this.get_score_stard_list_info_initial(e);
      this.get_province_list(e);
    },
    // 获取省份id并获取城市列表
    get_province_info(e) {
      this.form.province_id = e;
      this.form.city_id = "";
      this.get_city_list(e);
    },
    // 获取城市id
    get_city_info(e) {
      this.form.city_id = e;
    },
    get_retail_area_type_info(e) {
      this.form.retail_area_type_id = e;
    },
    // 获取评分标准面积id
    select_store_area(e) {
      this.form.area_score_id = e;
    },
    // 获取评分标准营业额id
    get_turnover_score_info(e) {
      this.form.turnover_score_id = e;
    },
    // 获取评分标准smok营业额id
    get_smokturnover_score_info(e) {
      this.form.smokturnover_score_id = e;
    },
    // 获取评分等级
    get_grade_level(e) {
      this.form.grade_level = e;
    },
    // 查询门店
    query_store_info() {
      let _me = this;
      _me.loading = true;
      let params = {
        country_id: _me.form.country_id,
        province_id: _me.form.province_id,
        city_id: _me.form.city_id,
        company_name: _me.form.company_name,
        page_flag: _me.form.page_flag,
        page_size: _me.page_size,
        page_number: _me.page_number,
        sort_fields: "",
        retail_area_type_id: _me.form.retail_area_type_id,
        area_size_range_id_list: _me.form.area_score_id,
        turnover_range_id_list: _me.form.turnover_score_id,
        smok_turnover_range_id_list: _me.form.smokturnover_score_id,
        grade_level: _me.form.grade_level
      };
      _me.$common
        .httpPost("/api/store/admin/find/list", params)
        .then(res => {
          _me.loading = false;
          if (res.code == 1000000) {
            if (res.data.array) {
              res.data.array.forEach((item, index) => {
                item.country_name = _me.$common.get_country_related_info(
                  item.country_id
                ).name;
                item.province_name = _me.$common.get_province_related_info(
                  item.province_id
                ).name;
                item.city_name = _me.$common.get_city_related_info(
                  item.city_id
                ).name;
                item.retail_area_type_name = _me.$common.get_retail_area_name(
                  item.retail_area_type_id
                );
                // 等级对应转换
                switch (item.grade) {
                  case 1:
                    item.transformed_grade = "A";
                    break;
                  case 2:
                    item.transformed_grade = "B";
                    break;
                  case 3:
                    item.transformed_grade = "C";
                    break;
                }
              });
              _me.store_info_list = res.data.array;
              _me.page_total = res.data.total;
            } else {
              _me.store_info_list = [];
            }
          } else {
            _me.$message.error(res.message);
          }
        })
        .catch(err => {
          _me.loading = false;
          if (err.code == 1000009 || err.code == 1000007) {
            this.$router.push("sign-in");
          }
          _me.$message.error(err.message);
        });
    },
    // 切换新版数据和旧版数据
    switch_new_old(value) {
      if (value) {
        this.form.page_flag = 1;
      } else {
        this.form.page_flag = 2;
      }
    },
    handleSizeChange(val) {
      this.page_size = val;
      this.query_store_info();
    },
    // 切换页码
    currentChangeOnclick(number) {
      this.page_number = number;
      this.query_store_info();
    },
    // 编辑
    edit_model(scope_params) {
      this.$router.push("edit-store-info-detail?id=" + scope_params.id);
    },
    // 删除单挑门店
    remove_model(scope_params) {
      let _me = this;
      _me
        .$confirm(
          _me.$t("commonInfo.DeleteItemWarning"),
          _me.$t("commonInfo.Tips"),
          {
            confirmButtonText: _me.$t("commonInfo.Confirm"),
            cancelButtonText: _me.$t("commonInfo.Cancel"),
            type: "warning"
          }
        )
        .then(() => {
          _me.remove_item(scope_params);
        })
        .catch(() => {
          // eslint-disable-next-line no-console
        });
    },
    remove_item(scope_params) {
      let _me = this;
      _me.loading = true;
      let params = {
        id: scope_params.id
      };
      this.$common
        .httpPost("/api/store/admin/delete/one", params)
        .then(res => {
          _me.loading = false;
          if (res.code == "1000000") {
            _me.$message.success(_me.$t("commonInfo.DeleteSucceed"));
            _me.query_store_info();
          } else {
            _me.$message.error(res.message);
          }
        })
        .catch(err => {
          _me.loading = false;
          if (err.code == 1000009 || err.code == 1000007) {
            _me.$router.push("sign-in");
          }
          _me.$message.error(err.message);
        });
    },
    // 导出excel
    export_excel() {
      this.loading = true;
      let _me = this;
      let params = {
        country_id: _me.form.country_id,
        province_id: _me.form.province_id,
        city_id: _me.form.city_id,
        company_name: _me.form.company_name,
        page_flag: _me.form.page_flag,
        page_size: _me.page_size,
        page_number: _me.page_number,
        sort_fields: "",
        retail_area_type_id: _me.form.retail_area_type_id,
        area_size_range_id_list: _me.form.area_score_id,
        turnover_range_id_list: _me.form.turnover_score_id,
        smok_turnover_range_id_list: _me.form.smokturnover_score_id,
        grade_level: _me.form.grade_level
      };
      _me.$common
        .httpPostBlob("/api/store/admin/download/excel", params)
        .then(res => {
          let content_disposition = decodeURI(
            res.headers["content-disposition"]
          ); //解码后获取文件名字
          content_disposition = content_disposition.substring(
            content_disposition.indexOf("utf-8") + 7
          );
          res = res.data;
          _me.loading = false;
          if (res && res.size > 0) {
            const blob = new Blob([res]);
            // const fileName = "刮刮码.xlsx"; //下载文件名称
            const elink = document.createElement("a");
            elink.download = content_disposition;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
          } else {
            _me.$message.error(res.message);
          }
        })
        .catch(err => {
          _me.loading = false;
          if (err.code == 1000009 || err.code == 1000007) {
            _me.$router.push("sign-in");
          }
          _me.$message.error(err.message);
        });
    },
    // 文件上传触发按钮
    trigger_upload_button() {
      this.$refs.upload_file_button.value = "";
      this.$refs.upload_file_button.click();
    },
    // 更新评分
    update_score() {
      let _me = this;
      _me.loading = true;
      let params = {};
      this.$common
        .httpGet("/api/store/admin/renew/score", params)
        .then(res => {
          _me.loading = false;
          if (res.code == "1000000") {
            _me.$message.success(_me.$t("commonInfo.UpdateSucceed"));
            this.query_store_info();
          } else {
            _me.$message.error(res.message);
          }
        })
        .catch(err => {
          _me.loading = false;
          if (err.code == 1000009 || err.code == 1000007) {
            _me.$router.push("sign-in");
          }
          _me.$message.error(err.message);
        });
    },
    // 初始化国家列表
    get_country_list_initial() {
      this.$common
        .get_storage_list(
          "country_list",
          "http_get",
          "/api/address/country/find/list"
        )
        .then(res => {
          this.form.country_list = res;
          // 默认给国家赋初值
          // this.form.country_list[0].name = res[0].name;
          // this.form.country_list[0].id = res[0].id;
          // this.form.country_id = res[0].id;
        })
        .catch(err => {});
    },
    // 初始化省份列表
    get_province_list_initial() {
      this.$common
        .get_storage_list(
          "province_list",
          "http_post",
          "/api/address/province/find/list"
        )
        .then(res => {
          this.form.province_list = res;
          // 默认给省份赋初值
          // this.form.province_list[0].name = res[0].name;
          // this.form.province_list[0].id = res[0].id;
          // this.form.province_id = res[0].id;
        })
        .catch(err => {});
    },
    // 初始化城市列表
    get_city_list_initial() {
      this.$common
        .get_storage_list(
          "city_list",
          "http_post",
          "/api/address/city/find/list"
        )
        .then(res => {
          this.form.city_list = res;
          // 默认给城市赋初值
          // this.form.city_list[0].name = res[0].name;
          // this.form.city_list[0].id = res[0].id;
          // this.form.city_id = res[0].id;
          // 初始化获取表格(必须等城市信息获取到才能渲染表格)
          this.query_store_info();
        })
        .catch(err => {});
    },
    // 获取零售区类型列表
    get_retail_area_type_list_initial() {
      this.$common
        .get_storage_list(
          "retail_area_type_list",
          "http_get",
          "/api/store/admin/retail/area/type/find/list"
        )
        .then(res => {
          this.form.retail_area_type_list = res;
        })
        .catch(err => {});
    },
    // 初始化评分标准
    get_score_stard_list_info_initial(country_id) {
      this.$common
        .get_storage_list(
          "score_stard_list",
          "http_get",
          "/api/grade/admin/find/list"
        )
        .then(res => {
          // 获取评分标准里面积范围列表
          if (country_id) {
            res = res.filter((item, index) => {
              return item.country_id == country_id;
            });
          }
          this.form.area_score_list = res[0].area_score_list;
          let country_related_info = this.$common.get_country_related_info(
            country_id
          );
          let area_unit = " " + country_related_info.area_unit;
          let turnover_unit = " " + country_related_info.turnover_unit;
          this.form.area_score_list.forEach((item, index) => {
            let max = item.max_size,
              min = item.min_size;
            if (min == max) {
              item.size_range = max;
            } else if (max == -1) {
              item.size_range = ">" + min;
            } else {
              item.size_range = min + " - " + max;
            }
            item.area_unit = area_unit;
          });

          // 获取评分标准营业额范围列表
          this.form.turnover_score_list = res[0].turnover_score_list;
          this.form.turnover_score_list.forEach((item, index) => {
            let max = item.max_revenue,
              min = item.min_revenue;
            if (min == max) {
              item.size_range = max;
            } else if (max == -1) {
              item.size_range = ">" + min;
            } else {
              item.size_range = min + " - " + max;
            }
            item.turnover_unit = turnover_unit;
          });
          // 获取评分标准smok营业额范围列表
          this.form.smok_turnover_score_list = res[0].smok_turnover_score_list;
          this.form.smok_turnover_score_list.forEach((item, index) => {
            let max = item.max_revenue,
              min = item.min_revenue;
            if (min == max) {
              item.size_range = max;
            } else if (max == -1) {
              item.size_range = ">" + min;
            } else {
              item.size_range = min + " - " + max;
            }
            item.turnover_unit = turnover_unit;
          });
        })
        .catch(err => {});
    }
  },
  created() {
    // this.query_store_info();
  },
  mounted() {
    // 初始化国家列表
    this.get_country_list_initial();
    // 初始化省份列表
    this.get_province_list_initial();
    // 初始化城市列表
    this.get_city_list_initial();
    // 初始化零售区类型
    this.get_retail_area_type_list_initial();
    // 初始化评分标准
    // this.get_score_stard_list_info_initial();
    // this.$common.get_retail_area_list_info();
    // 获取零售区类型
    // this.$common.get_retail_type_list_info();

    // 获取国家地区列表
    // this.get_address_list_info();
  },
  watch: {
    "form.country_id"() {
      if (this.form.country_id) {
        this.country_focus_flag = false;
      } else {
        this.country_focus_flag = true;
      }
    }
  }
};
</script>

<style scoped>
.banner-head {
  /*background-color: white;*/
  background-color: #f1f1f1;
  height: 60px;
}

.head-info {
  color: #ffffff;
}
</style>

